import React from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import {Modal, Button} from 'react-bootstrap';
import {css} from 'aphrodite';
import AutoLoginButton from '../autoLoginButton';
import {getSettings} from 'selectors/settings';
import {getResolvedLoginSettings} from 'services/authentication';

/**
 * HCP Verification Modal Component
 * Shows healthcare professional verification modal
 *
 * @param {Object} props
 * @param {Function} props.onAccept - Handler for accept button
 * @param {Function} props.onReject - Handler for reject button
 * @param {Object} props.styleSheet - Aphrodite styleSheet object
 * @param {boolean} props.show - Whether to show the modal
 */
const HcpVerification = ({onAccept, onReject, styleSheet, show = true}) => {
  const settings = useSelector(getSettings);
  const loginSettings = getResolvedLoginSettings(settings);

  const errorMessages = {
    apiUnavailable: loginSettings.error.apiUnavailable,
    npiIncorrect: loginSettings.error.npiIncorrect
  };

  return (
    <Modal
      data-testid="hcp-verification-modal"
      show={show}
      onHide={onReject}
      aria-labelledby="hcp-verification-title"
      backdrop="static"
      backdropClassName={css(styleSheet.modalBackdrop)}
      dialogClassName="pal-modal"
      className={css(styleSheet.modal)}
    >
      <Modal.Header closeButton={false}>
        <Modal.Title id="hcp-verification-title" className="healthcare-modal-title">
          {settings.content.physicianVerificationPopup}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="healthcare-modal-body">
        {settings.content.physicianVerificationBanner}
      </Modal.Body>
      <Modal.Footer className="pal-modal-footer">
        {!settings.loginV2?.hcpVerification?.hideSecondaryButton && (
          <Button
            className={css(styleSheet.buttonSecondary, styleSheet.modalReject)}
            onClick={onReject}
          >
            {settings.content.physicianVerificationReject}
          </Button>
        )}
        <Button
          className={css(styleSheet.buttonPrimary, styleSheet.modalSuccess)}
          onClick={onAccept}
        >
          {settings.content.physicianVerificationAccept}
        </Button>
        {settings.autoLoginButton?.disabled != null && !settings.autoLoginButton.disabled &&
          <AutoLoginButton
            className={css(styleSheet.buttonPrimary, styleSheet.modalSuccess)}
            buttonLabel="Other"
            npiNumber={loginSettings.autoLoginNpi}
            errorMessages={errorMessages}
          />
        }
      </Modal.Footer>
    </Modal>
  );
};

HcpVerification.propTypes = {
  onAccept: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
  styleSheet: PropTypes.object.isRequired,
  show: PropTypes.bool
};

export default HcpVerification;
